import AddOptionsForm from "../../Form/AddOptionsForm";
import AddProductsFrom from "../../Form/AddProductsFrom";
import "../Modal.css";

const ModalAddOptions = ({ isVisible, onClose }) => {
  if (!isVisible) return null;
  return (
    <div
      className="fixed inset-0  bg-opacity-75 flex justify-center items-center z-50"
      style={{ backdropFilter: "blur(5px)" }}
    >
      <div className="bg-white rounded-lg shadow-custom-full w-[1000px] mx-5 sm:mx-auto">
        <div className="flex justify-between py-3 px-5 items-center border-b shadow-md bg-blue-500">
          <h1 className="text-white text-xl font-roboto text500">
            Add Options
          </h1>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-full flex justify-center items-center "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-8 w-8 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div className="bg-green p-5 h-[620px] overflow-y-auto shadow-lg ">
          <AddOptionsForm></AddOptionsForm>
        </div>
        <div className="flex  mx-5"></div>
      </div>
    </div>
  );
};

export default ModalAddOptions;